
import { create } from 'zustand';

interface EventsCopyStore {
  copiedEvents: string[]; // IDs of copied events
  sourceView: string;
  sourceDate?: Date;
  sourceRange?: { start: Date; end: Date };
  hasCopied: boolean;
  setCopiedEvents: (events: string[], sourceView: string, sourceDate?: Date, sourceRange?: { start: Date; end: Date }) => void;
  clearCopiedEvents: () => void;
}

export const useEventsCopy = create<EventsCopyStore>((set) => ({
  copiedEvents: [],
  sourceView: '',
  sourceDate: undefined,
  sourceRange: undefined,
  hasCopied: false,
  setCopiedEvents: (events, sourceView, sourceDate, sourceRange) => set({ 
    copiedEvents: events, 
    sourceView,
    sourceDate,
    sourceRange,
    hasCopied: true
  }),
  clearCopiedEvents: () => set({ 
    copiedEvents: [], 
    sourceView: '',
    sourceDate: undefined,
    sourceRange: undefined,
    hasCopied: false
  }),
}));
